import { SVGAttributes } from 'react';

export function SwitchIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      width="200"
      height="200"
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="20"
        y="20"
        width="160"
        height="160"
        rx="30"
        stroke="currentColor"
        strokeWidth="15"
      />
      <path
        d="M60,75 L80,75 L120,125 L140,125"
        stroke="currentColor"
        strokeWidth="15"
        fill="none"
        strokeLinecap="square"
      />
      <path
        d="M60,125 L80,125 L120,75 L140,75"
        stroke="currentColor"
        strokeWidth="15"
        fill="none"
        strokeLinecap="square"
      />
      <polygon points="40,75 65,55 65,95" fill="currentColor" />
      <polygon points="40,125 65,105 65,145" fill="currentColor" />
      <polygon points="160,75 135,55 135,95" fill="currentColor" />
      <polygon points="160,125 135,105 135,145" fill="currentColor" />
    </svg>
  );
}
